import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox, Label } from '@massilia/ui';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldError } from './field-error';
const STABLE_ARRAY = [];
export default function MultiSelectAutocompleteField({ disabled, emptyMessage, isLoading, label, options, placeholder, }) {
    const field = useFieldContext();
    const value = field.state.value ?? STABLE_ARRAY;
    const errors = field.state.meta.errors;
    return (_jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [label && _jsx(Label, { className: "text-sm font-medium md:text-[16px]", children: label }), _jsx(Combobox, { disabled: disabled, emptyMessage: emptyMessage, isLoading: isLoading, mode: "multi", onChange: field.handleChange, options: options, placeholder: placeholder, value: value }), _jsx(FieldError, { errors: errors })] }));
}
